"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcDataAutocompleteField2 = void 0;
var react_1 = __importStar(require("react"));
var client_1 = require("@apollo/client");
var util_1 = require("@aperza/util");
var ac_ui_1 = require("@aperza/ac-ui");
var AcDataAutocompleteField2 = function (_a) {
    var query = _a.query, queryLimit = _a.queryLimit, getQueryVariable = _a.getQueryVariable, initialSelectedDataRow = _a.initialSelectedDataRow, pathToPage = _a.pathToPage, autocompleteProps = __rest(_a, ["query", "queryLimit", "getQueryVariable", "initialSelectedDataRow", "pathToPage"]);
    var _b = __read(client_1.useLazyQuery(query), 2), suggestDataRows = _b[0], _c = _b[1], data = _c.data, loading = _c.loading;
    var _d = __read(react_1.useState(initialSelectedDataRow), 2), selectedDataRow = _d[0], setSelectedDataRow = _d[1];
    var value = autocompleteProps.value, getItemId = autocompleteProps.getItemId, onChange = autocompleteProps.onChange, allowTextInput = autocompleteProps.allowTextInput;
    var debouncedExecuteLazyQuery = react_1.useMemo(function () {
        var executeLazyQuery = function (qvar, _queryLimit) {
            suggestDataRows({
                variables: __assign(__assign({}, qvar), { limit: _queryLimit }),
            });
        };
        return util_1.DebounceUtil.debounce(executeLazyQuery, 500);
    }, [suggestDataRows]);
    var refetchQuery = react_1.useCallback(function (_value) {
        var qvar = getQueryVariable(_value);
        if (_value && qvar) {
            if (selectedDataRow && getItemId(_value) === getItemId(selectedDataRow))
                return;
            debouncedExecuteLazyQuery(qvar, queryLimit);
        }
    }, [debouncedExecuteLazyQuery, getItemId, getQueryVariable, queryLimit, selectedDataRow]);
    react_1.useEffect(function () {
        refetchQuery(value);
    }, [refetchQuery, value]);
    var onChangeInputValue = function (e, _value) {
        if (!allowTextInput) {
            refetchQuery(_value);
        }
    };
    /**
     * Updated initialSelectedDataRow means the Field is initialized to handle a new domain
     */
    react_1.useEffect(function () {
        if (initialSelectedDataRow) {
            setSelectedDataRow(initialSelectedDataRow);
        }
    }, [initialSelectedDataRow]);
    react_1.useEffect(function () {
        // Only clear value if selectedDataRow is set to null. Cleared by chip.
        // Otherwise, the initial value will be changed to ''
        if (selectedDataRow === null) {
            // onChangeValue('', undefined);
        }
    }, [selectedDataRow]);
    var getPageData = react_1.useCallback(function () {
        return util_1.ObjectUtil.get(data, pathToPage);
    }, [data, pathToPage]);
    var dataRows = react_1.useMemo(function () {
        var rows = selectedDataRow ? [selectedDataRow] : [];
        if (!data) {
            return rows;
        }
        return rows.concat(getPageData());
    }, [data, getPageData, selectedDataRow]);
    var onDeleteItem = function (item) {
        setSelectedDataRow(undefined);
    };
    var _onChange = function (id, _value, items) {
        setSelectedDataRow(items);
        onChange === null || onChange === void 0 ? void 0 : onChange(id, _value, items);
    };
    return (react_1.default.createElement(ac_ui_1.AcAutocompleteField2, __assign({}, autocompleteProps, { loading: loading, items: dataRows, onDeleteItem: onDeleteItem, onChange: _onChange, onChangeInputValue: onChangeInputValue })));
};
exports.AcDataAutocompleteField2 = AcDataAutocompleteField2;
exports.AcDataAutocompleteField2.displayName = 'AcDataAutocompleteField2';
//# sourceMappingURL=AcDataAutocompleteField2.js.map